var render, staticRenderFns
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"
import style0 from "./text.vue?vue&type=style&index=0&id=0d9f48fe&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports